export const incidentImpactLevels = {
  none: 'none',
  minor: 'minor',
  major: 'major',
  critical: 'critical',
};
